module.exports = __webpack_public_path__ + "img/batch-directive-detail.385cc177.svg";